import(/* webpackMode: "eager", webpackExports: ["WeChatCopyButton"] */ "/opt/buildhome/repo/app/(main)/collabs/WeChatCopyButton.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/image-component.js");
